"use client";
import ClientBodyWrapper from "@/components/structure/ClientBodyWrapper";
import { SplashScreenV2 } from "@/components/structure/splash/SplashScreenV2";
import { gsap, ScrollTrigger } from "@/lib/gsap";
/**
 * Client component for initializing global clientside scripts
 *
 * TODO:
 *  - Continuous Scrolling: https://codepen.io/GreenSock/pen/XWzRraJ
 */
import { useEffect, useState } from "react";

interface ClientWrapperProps {
  children: React.ReactNode;
}

export default function ClientSplashScreenWrapper({ children }: ClientWrapperProps) {
  // TODO: revisit animated favicon
  /*
     // useSpinFavicon("/favicon/favicon-32x32.png", 50);
     usePulseFavicon("/favicon/favicon-32x32.png", 100);
  */
  const disableSplash = process.env.NEXT_PUBLIC_DISABLE_SPLASH === "true";

  const [showSplash, setShowSplash] = useState(!disableSplash);

  useEffect(() => {
    console.log("load ClientSplashScreenWrapper");
    // Register GSAP plugins
    if (typeof window !== "undefined") {
      gsap.registerPlugin(ScrollTrigger);
    }

    if (!showSplash) {
      // Only initialize GSAP effects after splash screen is gone
      gsap.to("body", {
        opacity: 1,
        // TODO: figure out perfect duration...
        duration: 0.3,
      });

      // Animate the navbar logo when splash completes
      gsap.fromTo(
        ".navbar-logo",
        { y: -50, opacity: 0 },
        {
          y: 0,
          opacity: 1,
          // TODO: figure out perfect duration...
          // duration: 0.4,
          duration: 0.2,
          ease: "power2.out",
        },
      );

      // Scroll-triggered logo animation as fallback
      ScrollTrigger.create({
        trigger: "body",
        start: "top top",
        endTrigger: "body",
        end: "bottom bottom",
        onEnter: () => {
          if (!showSplash) {
            gsap.to(".navbar-logo", {
              opacity: 1,
              // TODO: figure out perfect duration...
              // duration: 0.5
              duration: 0.3,
            });
          }
        },
      });
    }

    return () => {
      // Clean up ScrollTrigger instances when component unmounts
      if (typeof window !== "undefined") {
        ScrollTrigger.getAll().forEach((trigger) => trigger.kill());
      }
    };
  }, [showSplash]);

  const handleSplashComplete = () => {
    console.log("handleSplashComplete");
    setShowSplash(false);
  };
  return (
    <div className="">
      {showSplash ? (
        <SplashScreenV2
          onComplete={handleSplashComplete}
          duration={500}
          scale={1.12}
          // logoSrc="/images/logo/atc-logo-full-transparent.png"
          logoSrc="/images/logo/atc-logo-abbreviated-transparent.png"
          initialScale={0.3}
        />
      ) : (
        <>
          <ClientBodyWrapper>{children}</ClientBodyWrapper>
        </>
      )}
    </div>
  );
}
